let counter = 0;
const recursiveCall = (property: string, maxTries: number): Promise<boolean> =>
  new Promise(resolve => {
    setTimeout(() => {
      if (window[property as never]) {
        return resolve(true);
      }

      if (counter >= maxTries) {
        return resolve(false);
      }

      counter += 1;

      return resolve(recursiveCall(property, maxTries));
    }, 100);
  });

export const checkIfWindowPropertyIsLoaded = (property: string): Promise<boolean> =>
  new Promise((resolve): void => {
    counter = 0;
    resolve(recursiveCall(property, 20));
  });
